export default __webpack_public_path__ + "static/media/calendarIcon.7020c5d3.svg";